module.exports = __webpack_public_path__ + "static/media/25.0a481b8f.jpg";